<div class="text" [ngStyle]="{'color': color}" [innerHTML]="_text | safeHtml"></div>
